import { ref } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import { TaxFormDraft } from "@/views/PageBecomeCreator/types";

export function useBecomeCreatorState() {
  const { authUser } = useAuthUser();
  const lastStep = ref(0);
  const taxFormDraft = ref<TaxFormDraft | null>(null);

  const getData = async () => {
    if (!authUser.value) return;
    const response = await providers.UserFrontendData.search({ userId: authUser.value.id });
    lastStep.value = (response?.becameCreatorState?.lastStep as number) ?? 0;
    taxFormDraft.value = (response?.becameCreatorState?.taxFormDraft as TaxFormDraft) ?? null;
  };

  // Backend replaces becameCreatorState wholesale, so the draft is resent on every
  // update: an object stores it, null clears it, omitted preserves what's persisted.
  const update = async (step: number, draft?: TaxFormDraft | null) => {
    if (!authUser.value) return;
    let taxForm = draft;
    if (taxForm === undefined) {
      const response = await providers.UserFrontendData.search({ userId: authUser.value.id });
      taxForm = (response?.becameCreatorState?.taxFormDraft as TaxFormDraft) ?? null;
    }
    lastStep.value = step;
    taxFormDraft.value = taxForm;
    return providers.UserFrontendData.update({
      data: {
        userId: authUser.value.id,
        becameCreatorState: { lastStep: step, ...(taxForm ? { taxFormDraft: taxForm } : {}) },
      },
    });
  };

  return {
    lastStep,
    taxFormDraft,
    update,
    getData,
  };
}
